import * as React from 'react';
import { Activity, Message, User, CardAction, Attachment } from 'botframework-directlinejs';

export interface EscalationProps {
    message: Message;
    candidates: string[];
    onShow: () => void;
    onCardAction: (type: string, value: string) => void;
    options: any;
}

export interface EscalationState {
    eval: boolean;
    otsuuLoginState: boolean;
    escalationEntitiy: any;
}

export class EscalationView extends React.Component<EscalationProps,EscalationState > {

    constructor(props: EscalationProps,state: EscalationState) {
        super(props);

        this.state = {
            eval : true,
            otsuuLoginState : false,
            escalationEntitiy : (this.props.message.entities || []).find((x) => x.escalation)
        }
    }

    setStateEval = () => {
        this.setState({ eval: false });
    };

    linkEscalationStart = () => {
        if (this.props.options.mannedLink) {
            window.open(this.props.options.mannedLink);
        }
    };

    render() {

        if (!this.state.escalationEntitiy) {
            return null;
        }
        //cookieの取得
        let tmpOtsuuLoginState:boolean;
        var r = document.cookie.split(';');
        r.forEach(function(value){
            //cookie名と値に分ける
            var content = value.split('=');
            if(content[0].trim() == "otsuuLoginState"){
                tmpOtsuuLoginState = (decodeURIComponent(content[1]).toLowerCase() == "true") ? true : false;
            }
        })

        if(tmpOtsuuLoginState != this.state.otsuuLoginState)
            this.setState({ otsuuLoginState: tmpOtsuuLoginState});
        //escalationフラグをクッキーに設定
        document.cookie = "escalation_flg=true";

        const escalationComponent = (() =>{
            return (
                <div className="guide-manned-chatbot">
                { this.state.otsuuLoginState ?
					<p className="message">ログインされている大塚IDでチャットを開始しますか？</p>
                :
					<p className="message">ご利用は大塚IDのログインが必要です。チャットを開始しますか？</p>
                }
                    <div className="guide-buttons">
                        <button type="button"
                                disabled={ !this.state.eval }
                                onClick={ this.linkEscalationStart }>はい</button>
                        <button type="button"
                                disabled={ !this.state.eval }
                                onClick={ this.setStateEval }>いいえ</button>
                    </div>
                    { !this.state.eval ?
                        <p>引き続きご質問をどうぞ。</p>
                    : null }
                </div>
            );
        })();

        return (
            <div>
            {escalationComponent}
            </div>
        );
   }

}


// WEBPACK FOOTER //
// ./src/Escalation.tsx